import { Linkable, LinkableImpl } from "./linkable";
import { EntityLinkType } from "./entityLinkType";

export enum LinkPerspective {
  OUTWARD = 'OUTWARD',
  INWARD = 'INWARD'
}

/**
 * LinkedEntityConnection represents a resolved entity link with perspective-based information.
 * This is returned by the backend when querying linked entities, providing pre-computed
 * labels and the resolved linked entity.
 */
export class LinkedEntityConnection {
  linkId: string;
  linkType: EntityLinkType | string;
  perspective: LinkPerspective;
  linkLabel: string;
  linkedEntity: Linkable;
  role?: string;
  isSystemManaged?: boolean;

  constructor(payload?: any) {
    if (payload) {
      this.linkId = payload.linkId;
      this.linkType = payload.linkType;
      this.perspective = payload.perspective;
      this.linkLabel = payload.linkLabel;
      this.linkedEntity = payload.linkedEntity ? new LinkableImpl(payload.linkedEntity) : undefined;
      this.role = payload.role;
      this.isSystemManaged = payload.isSystemManaged;
    }
  }

  /**
   * Creates LinkedEntityConnection instances from a result array
   * @param result Array of any
   * @returns Array of LinkedEntityConnection
   */
  static createLinkedEntityConnections(result: Array<any>): LinkedEntityConnection[] {
    const connections = new Array<LinkedEntityConnection>();
    if (result) {
      result.map((item) => {
        connections.push(new LinkedEntityConnection(item));
      });
    }
    return connections;
  }
}
